import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RequestModel } from 'src/app/models/request/request-model';
import { MetaModelService } from 'src/app/services/metamodel/metamodel-provider.service';
import { RestProviderService } from 'src/app/services/rest-provider/rest-provider.service';
import { SearchService } from 'src/app/services/search/search.service';
import { TranslationsProviderService } from 'src/app/services/translations-provider/translations-provider.service';
import { UserService } from 'src/app/services/user/user-provider.service';
import { DynamicLoadingUtil } from 'src/app/shared/helpers/dynamic-loading-util';
import { SemSearchComponent } from '../../sem-search/sem-search.component';

export class UserModel {

  public OldPassword: string = "";
  public NewPassword: string = "";
  public NewPasswordRepeat: string = "";
  public UserName: string = "";
  public Email: string = "";
  public Name: string = "";
  public Surname: string = "";

}

@Component({
  selector: 'app-sem-user-profile-dialog',
  templateUrl: './sem-user-profile-dialog.component.html',
  styleUrls: ['./sem-user-profile-dialog.component.css']
})
export class SemUserProfileDialogComponent implements OnInit {

  public userModel: UserModel = new UserModel();
  public statusMessage: string = "";
  public initials:string = "";

  constructor(
    public dialogRef: MatDialogRef<SemSearchComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    public translationsService: TranslationsProviderService,
    public metaModelService: MetaModelService,
    public userService: UserService,
    public searchService: SearchService,
    public restClient: RestProviderService) {
  }

  ngOnInit(): void {
    var user = this.restClient.currentUser;

    this.userModel.Email = this.restClient.currentUser.Email;
    this.userModel.Name = this.restClient.currentUser.Name;
    this.userModel.Surname = this.restClient.currentUser.Surname;

    this.getInitials();
  }

  changePass() {
    var requestModel = new RequestModel();
    requestModel.url = "api/user/change/pass";
    this.userModel.UserName = this.restClient.currentUser.Username;
    requestModel.data = this.userModel;

    if (typeof DynamicLoadingUtil.loader != "undefined") {
      DynamicLoadingUtil.loader.showLoader = true;
    }

    var response = this.restClient.getDataPOST(requestModel).subscribe(data => {

      this.statusMessage = data["Message"];
      setTimeout(() => { this.statusMessage = ""; }, 3000);

      if (typeof DynamicLoadingUtil.loader != "undefined") {
        DynamicLoadingUtil.loader.showLoader = false;
      }

    }, error => {
      this.statusMessage = "Prišlo je do napake, prosim poskusite znova";
      setTimeout(() => { this.statusMessage = ""; }, 3000);
      console.log("Error updating profile:", error);

      if (typeof DynamicLoadingUtil.loader != "undefined") {
        DynamicLoadingUtil.loader.showLoader = false;
      }
    });
  }

  changeInfo() {
    var requestModel = new RequestModel();
    requestModel.url = "api/user/change/info";
    this.userModel.UserName = this.restClient.currentUser.Username;
    requestModel.data = this.userModel;

    if (typeof DynamicLoadingUtil.loader != "undefined") {
      DynamicLoadingUtil.loader.showLoader = true;
    }

    var response = this.restClient.getDataPOST(requestModel).subscribe(data => {

      this.statusMessage = data["Message"];
      setTimeout(() => { this.statusMessage = ""; }, 3000);

      this.restClient.currentUser.Email = this.userModel.Email;
      this.restClient.currentUser.Name = this.userModel.Name;
      this.restClient.currentUser.Surname = this.userModel.Surname;
      this.restClient.currentUser.FullName = data["FullName"];
      this.getInitials();

      if (typeof DynamicLoadingUtil.loader != "undefined") {
        DynamicLoadingUtil.loader.showLoader = false;
      }

    }, error => {
      this.statusMessage = "Prišlo je do napake, prosim poskusite znova";
      setTimeout(() => { this.statusMessage = ""; }, 3000);
      console.log("Error updating profile:", error);

      if (typeof DynamicLoadingUtil.loader != "undefined") {
        DynamicLoadingUtil.loader.showLoader = false;
      }
    });
  }

  logout(){
    this.userService.logout();
  }

  tabChanged(tab){
    this.statusMessage = "";
  }

  getInitials(){
    this.initials = "";

    if(this.restClient.currentUser.Name && this.restClient.currentUser.Name.length > 0){
      this.initials += this.restClient.currentUser.Name[0];
    }
    if(this.restClient.currentUser.Surname && this.restClient.currentUser.Surname.length > 0){
      this.initials += this.restClient.currentUser.Surname[0];
    }
  }

}
